import React from 'react';

const MediaMetadataForm = ({ mediaMetadata, onChange }) => (
    <div className="card mb-4">
        <div className="card-header">
            <strong>Media Information</strong>
        </div>
        <div className="card-body">
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="media-writer" className="form-label">Writer</label>
                    <input
                        id="media-writer"
                        type="text"
                        value={mediaMetadata.writer}
                        onChange={(event) => onChange('writer', event.target.value)}
                        className="form-control"
                        placeholder="Enter writer name"
                    />
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="media-composer" className="form-label">Composer</label>
                    <input
                        id="media-composer"
                        type="text"
                        value={mediaMetadata.composer}
                        onChange={(event) => onChange('composer', event.target.value)}
                        className="form-control"
                        placeholder="Enter composer name"
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="media-copyright" className="form-label">Copyright</label>
                    <input
                        id="media-copyright"
                        type="text"
                        value={mediaMetadata.copyright}
                        onChange={(event) => onChange('copyright', event.target.value)}
                        className="form-control"
                        placeholder="e.g., © 2024 Artist Name"
                    />
                </div>
                <div className="col-md-6 mb-3">
                    <label htmlFor="media-links" className="form-label">Links</label>
                    <input
                        id="media-links"
                        type="text"
                        value={mediaMetadata.links}
                        onChange={(event) => onChange('links', event.target.value)}
                        className="form-control"
                        placeholder="e.g., Spotify, YouTube links"
                    />
                </div>
            </div>
        </div>
    </div>
);

export default MediaMetadataForm;
